import React from "react";

const EngineSpecs = () => {
  return (
    <div style={{
      fontFamily: "Arial, sans-serif",
      maxWidth: "400px",
      margin: "0 auto",
      padding: "20px",
      border: "1px solid #ddd",
      borderRadius: "5px",
      lineHeight: "1.4"
    }}>
      {/* Engine Specs Section */}
      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Engine Displacement</div>
        <div style={{ fontSize: "14px", color: "#555" }}>236.2 cc</div>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Maximum Net Power</div>
        <div style={{ fontSize: "14px", color: "#555" }}>7.45 kW</div>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Dimensions (Tray Size)</div>
        <div style={{ fontSize: "14px", color: "#555" }}>Length - 1840 mm, Width - 1425 mm</div>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Fuel Tank Capacity</div>
        <div style={{ fontSize: "14px", color: "#555" }}>40 L</div>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Clutch Type</div>
        <div style={{ fontSize: "14px", color: "#555" }}>Wet, Multiplate</div>
      </div>

      <div style={{ marginBottom: "16px" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Drive Shaft</div>
        <div style={{ fontSize: "14px", color: "#555" }}>CV shaft</div>
      </div>

      {/* Divider */}
      <div style={{ 
        height: "1px", 
        backgroundColor: "#ddd", 
        margin: "20px 0",
        width: "100%"
      }}></div>

      {/* CMG Section */}
      <div style={{ marginBottom: "20px" }}>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>CMG</div>
        <div style={{ fontSize: "14px", color: "#555" }}>
          Get up and close with the Maxima C (All IP6 & CN6 variants are bi-fuel)
        </div>
      </div>

      {/* Diesel Section */}
      <div>
        <div style={{ fontWeight: "bold", fontSize: "16px" }}>Diesel</div>
        <div style={{ fontSize: "14px", color: "#555" }}>Colour options</div>
        <div style={{ fontSize: "14px", color: "#555" }}>Green</div>
      </div>
    </div>
  );
};

export default EngineSpecs;